import { Component, Input, OnInit, ViewChild,Output,EventEmitter } from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { DragulaService  } from "ng2-dragula"
import {DataService} from '../../../services/data.service';
import {ApiService} from '../../../services/api.service';
import { GET_HOME_DASHBOARD_DATA, UPDATE_HOME_DASHBOARD_DATA } from '../../../../config';
import { Router } from '@angular/router';
import { Globals } from '../../../services/globals';
//import { L } from '@angular/core/src/render3';

@Component({
  selector: 'app-customize-dash',
  templateUrl: './customize-dash.component.html',
  styleUrls: ['./customize-dash.component.css']
})
export class CustomizeDashComponent implements OnInit {

  @ViewChild('customizePopup', {static:true}) customizePopup;
  @Input() btnTitle: string = 'Customize';
  @Input() modalTitle: string = 'Customize ';
  @Input() inputList: any;
  @Input() noAccessWidgetsLists:any;
  @Input() modalClass: string = '';

  @Output() customizeData:EventEmitter<string> = new EventEmitter();

  customizeList: any;
  selectAll: boolean = false;
  widgetOrderList = new Array<any>();
  popRef: NgbActiveModal;
  dragImg = '';
  assetsUrl = '';
  widgetsSetting: any;
  clientid : any;
  settingData: any;
  //noAccessWidgetsLists: any;  // these are widgets where access is not given
  showHomeDashboardView = false;
  insightDiscoverWidgets: any;

  constructor(  public globals: Globals,private router: Router, private apiService: ApiService,private dataService: DataService,private modalService: NgbModal,private _ds: DragulaService) {
      this.assetsUrl = this.globals.getAssetsUrl();
      this.dragImg = this.assetsUrl + 'assets/icons/icon-font/drag.svg';
  }

  ngOnInit() {

    this._ds.dragend().subscribe( val => {
    })

    //after dragging done on widgets popup
    this._ds.dropModel()
    .subscribe(value => {
      console.log(value);
      this.updateCustomizeList( value['sourceIndex'] , value['targetIndex'] );
    })

  }

  customizeSidedrawer() {
    console.log(this.widgetOrderList);
    this.customizeList = this.inputList.map((a) => ({ ...a }));
    console.log( " customizeList ", this.customizeList );
    this.updateSelectAllState();
    this.open( this.customizePopup );
  }

  /**
  * To open Bootstrap modal window
  * @param content
  */

  open(content) {
    this.popRef = this.modalService.open(content, {
      size: 'lg',
      windowClass: `right-side-modal ${this.modalClass}`,
      backdrop: 'static'
    });
  }

  onVisibilityChange( e, index ){
    this.customizeList[index]['visible'] = e;
    this.updateSelectAllState();
  }

  onSelectAllChange(isSelected: boolean): void {
    if (!Array.isArray(this.customizeList)) {
      return;
    }
    this.customizeList = this.customizeList.map((widget: any) => ({ ...widget, visible: isSelected }));
    this.updateSelectAllState();
  }

  private updateSelectAllState(): void {
    const isAllVisible = this.customizeList.every((widget: any) => widget?.visible === true)
    console.log('isAllVisible', isAllVisible);
    this.selectAll = Array.isArray(this.customizeList) && this.customizeList.length > 0
      ? this.customizeList.every((widget: any) => widget?.visible === true)
      : false;
  }

  updateCustomizeList( sourceIndex, targetIndex ){
    console.log(this.customizeList);
    let fromIndex = sourceIndex;
    let toIndex   = targetIndex;

    let tempCustomizeList = [ ];

    let gotMatchedIndex = false;
    let incrementIndex = false;
    let decrementIndex = false;

    for ( let index = 0; index < this.customizeList.length; index++ ) {

      let currIndex = index;

      if( index != fromIndex && index != toIndex ){
        if( incrementIndex ){
          currIndex  = index + 1;
        }
        if( decrementIndex ){
          currIndex  = index - 1;
        }
      }

      if ( index == fromIndex ) {   // if its From Index

        if( ! gotMatchedIndex ){
          gotMatchedIndex = true;
          incrementIndex = true;
          currIndex = index + 1;
        }
        else{    // if already done To Index
          if( incrementIndex ){
            currIndex  = index + 1;
          }
          if( decrementIndex ){
            currIndex  = index - 1;
          }
          incrementIndex = decrementIndex = false;
        }
      }

      if ( index == toIndex ) {   // if its To Index
        if( ! gotMatchedIndex ){
          gotMatchedIndex = true;
          decrementIndex = true;
          currIndex = fromIndex;
        }
        else{   // if already done from index
          currIndex = fromIndex;
          incrementIndex = decrementIndex = false;
        }
      }
      this.customizeList[ currIndex ]["order"] = index + 1;
      tempCustomizeList[index] =  this.customizeList[ currIndex ];
    }

    this.customizeList = [];
    this.customizeList = tempCustomizeList;
  }

  saveSettings(list:any){

    console.log( " Cutomize compo -Save click List ", list );
    this.customizeData.emit(list)
    this.popRef.close();
  }

  redirectoDetailedView(pagename){
    console.log( " redirectoDetailedView ", pagename )
    if( this.popRef ){
      this.popRef.close();
    }
  	this.router.navigate([pagename]);
  	return false;
  }

  /*
  getInitialWidgetList( ){

    this.dataService.pageLevelAccess_Map.subscribe( res => {

      if( res['home_dashboard'] ){    // if has home dashboard access

        this.showHomeDashboardView = true;
        this.clientid = res['clientid'];
        const now = new Date();

        // check session storage setting data
        if ( sessionStorage.getItem('homeSettings_' + this.clientid ) ) {

          // write a code to delete if expiry time spent -----
          let storage = JSON.parse( sessionStorage.getItem('homeSettings_' + this.clientid ) );

          if( now.getTime( ) > storage.expiry ) {  // if time elapsed then delete from storage

            console.log( "new-home-dash storage older than 2 hours delete storage " )
            // delete old session storage of home dashbord
            sessionStorage.removeItem( 'homeSettings_' + this.clientid );
            this.getInitialWidgetList( );
            return false;
          }
          else{
            this.widgetsSetting = storage.data.widgets;
            this.sortWidgets();
          }

        }
        else{   // if not found in session storage

          console.log( "new-home-dashboard calling GET_HOME_DASHBOARD_DATA  " )

          this.apiService.get( GET_HOME_DASHBOARD_DATA ).subscribe( result => {
            console.log( "GET_HOME_DASHBOARD_DATA  ", result )

            if (result['status'] === 'success') {

              if (typeof result['data'] === 'string') {
                this.settingData = JSON.parse( result['data'] );
              } else {
                this.settingData = result['data'];
              }

              this.clientid = this.settingData['cid'];

              if ( !sessionStorage.getItem('homeSettings_' + this.clientid ) ) {

                const homeSettings = {
                  data: this.settingData,
                  expiry: now.getTime() + 7200000,  // expiry time of 2 hrs
                };
                sessionStorage.setItem(
                  'homeSettings_' + this.clientid ,
                  JSON.stringify(homeSettings)
                );
              }

              this.widgetsSetting = this.settingData['widgets'];
              this.sortWidgets( );
            }

          })

        }

      }

    })

  }
  */

  /*
  sortWidgets() {
    this.widgetOrderList = [];

    this.noAccessWidgetsLists = [];   // No access widgets
    let tempNoAccessList = this.compulsoryItem;

    const keys = Object.keys(this.widgetsSetting);
    for (const key of keys) {

      if (this.widgetsSetting[key]) {
        const newObj = {
          id: key,
          order: this.widgetsSetting[key].order,
          name: this.widgetsSetting[key].title,
          visible: this.widgetsSetting[key].visible,
        };
        this.widgetOrderList.push(newObj);
      }

      delete tempNoAccessList[ key ];   // delete if access present
    }

    if( tempNoAccessList ){
      for( let key in tempNoAccessList ){
          const widgetObj = { "name" : tempNoAccessList[key]['name'], "page" : tempNoAccessList[key]['page'] };
          this.noAccessWidgetsLists.push( widgetObj )
      }
    }

    console.log( " sortWidgets -> widgetOrderList ", this.widgetOrderList );
    console.log( " sortWidgets -> noAccessWidgetsLists ", this.noAccessWidgetsLists );

    this.widgetOrderList = this.widgetOrderList.sort(
      (a, b) => a.order - b.order
    );

    const widgetVisibilty = this.widgetOrderList.filter(
      (item) => item.visible === true
    );

  }
  */


}
